import React, { useEffect, useState } from 'react';

import { DateFormat } from '@common/utils';

interface Props {
  estimate_timestamp?: number;
  updateEstimateInfo: () => void;
  className?: string;
}

export const ZigzinShippingTimer = React.memo(
  ({ estimate_timestamp = new Date().getTime(), updateEstimateInfo, className }: Props) => {
    const [time, setTime] = useState('');

    useEffect(() => {
      if (estimate_timestamp === 0) {
        return;
      }

      const start = new Date();
      const end = new Date(estimate_timestamp);

      if (start > end) {
        updateEstimateInfo();
      }

      const interval = setInterval(() => {
        setTime(DateFormat.distance(start, end, 'ko'));
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, [time]);

    return <span className={className}>{time}</span>;
  },
);
